<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>G/L Accounts Setup -> Default Accounts</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="DefaultSalesAccount" automplete="off" dense outlined
              v-model="record.DefaultSalesAccount" :items="accounts" label="Default Sales Account" item-text="Name"
              item-value="id" readonly filled></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="DefaultPaymentsAccount" automplete="off" dense outlined
              v-model="record.DefaultPaymentsAccount" :items="accounts" label="Default Payments Account"
              item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="DefaultPaymentsAccount" automplete="off" dense outlined
              v-model="record.DefaultCashAccount" :items="accounts" label="Default Cash Account" item-text="Name"
              item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="DefaultDebtorsAccount" automplete="off" dense outlined
              v-model="record.DefaultDebtorsAccount" :items="accounts" label="Debtors/ Acc. Receivable" item-text="Name"
              item-value="id" readonly filled></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="DefaultCreditorsAccount" automplete="off" dense outlined
              v-model="record.DefaultCreditorsAccount" :items="accounts" label="Debtors/ Acc. Payable" item-text="Name"
              item-value="id" readonly filled></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="DefaultInventoryAccount" automplete="off" dense outlined
              v-model="record.DefaultInventoryAccount" :items="accounts" label="Inventory A/C" item-text="Name"
              item-value="id" readonly filled></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="DefaultCogsAccount" automplete="off" dense outlined
              v-model="record.DefaultCogsAccount" :items="accounts" label="Cost Of Goods" item-text="Name"
              item-value="id" readonly filled></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="DefaultSalesReturnPayments" automplete="off" dense outlined
              v-model="record.DefaultSalesReturnPayments" :items="accounts" label="Default Sales Return Payments"
              item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="DefaultPurchasesReturnPayments" automplete="off" dense outlined
              v-model="record.DefaultPurchasesPaymentsReturn" :items="accounts"
              label="Default Purchases Return Payments" item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete automplete="off" dense outlined filled readonly v-model="record.DefaultCustomerAdvances"
              :items="accounts" label="Default Customer Advances" item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete automplete="off" dense outlined filled readonly v-model="record.DefaultSupplierAdvances"
              :items="accounts" label="Default Supplier Advances" item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete automplete="off" dense outlined v-model="record.DefaultReconciliationAccount"
              :items="accounts" label="Defaul Reconciliation Account" item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete automplete="off" dense outlined v-model="record.DefaultPurchaseTax" :items="taxGroups"
              label="Default Purchase Tax" item-text="name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete automplete="off" dense outlined v-model="record.DefaultSaleTax" :items="taxGroups"
              label="Default Sales Tax" item-text="name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-text-field type="number" autocomplete="off" outlined dense label="Default Custom Tax"
              v-model="record.DefaultCustomTax" :rules="inputRules"></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete v-show="IsDistributor == 'Y'" automplete="off" dense outlined
              v-model="record.DefaultWarehouse" :items="stores" label="Default warehouse" item-text="Name"
              item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete autocomplete="off" dense outlined v-model="record.DefaultDistributorCustomer"
              :items="customers" label="Default Distributor Customer" item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="12">
            <v-btn class="primary" @click="save" :loading="$store.state.btnLoader">
              <v-icon left>mdi-content-save</v-icon>Update
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {},
      selectedCustomer: null,
      customers: [],
      select: "",
      searchCustomers: null,
      searchNaivasCustomers: null,
      accounts: [],
      naivasCustomers: [],
      stores: [],
      taxGroups: [],
      loader: false
    };
  },
  computed: {
    IsDistributor() {
      return localStorage.getItem("IsDistributor");
    }
  },
  watch: {

  },
  methods: {
    glAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/gl-integration`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.record = { ...res.ResponseData };
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    save() {
      const data = this.record;
      data.DefaultCustomTax = parseFloat(this.record.DefaultCustomTax);
      const url = "/gl-integration";
      const self = this;
      this.$store.commit("btnLoader", true);
      this.$store.commit("loader", true);
      this.$store
        .dispatch("put", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$store.commit("loader", false);
            self.$refs.snackbar.show("Update successful", "green");
            //   self.glAccounts();
          } else {
            self.$store.commit("btnLoader", false);
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getTaxes() {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/tax-group`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.taxGroups = res.ResponseData;
            self.loading = false;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.loading = true;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
            self.loading = false;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([
      this.getStores(),
      this.getTaxes(),
      this.glAccounts(),
      this.getAccounts(),
      this.getCustomers()
    ]);
  }
};
</script>

<style lang="scss" scoped></style>